import { useMemo } from "react";
import { useRouter } from "next/router";

import {
    DRAWER_ACTIONS,
    useDrawerDispatch,
    useDrawerState,
} from "@hmn/coolinarika-web-core/context/Drawer";
import { useNotification, useTaxonomyMutate } from "@hmn/coolinarika-web-core/hooks";

import { withErrorBoundary } from "../ErrorBoundary";
import { Editor } from "./components/Editor";
import { Notification } from "./components/Notification";

const NOTIFICATION_ID = "collections-notification";

const CollectionsEdit = () => {
    const dispatch = useDrawerDispatch();
    const { push, query } = useRouter();
    const { id } = useMemo(() => query, [query]);
    const { content: collection } = useDrawerState();
    const { sendNotification } = useNotification({
        id: NOTIFICATION_ID,
    });

    const {
        taxons: categories,
        actions: categoryActionsNew,
        isLoading,
    } = useTaxonomyMutate({
        resource: "taxonomies",
        entity: "coolinarika-user-categories",
        bag: "protected-coolinarika-user-categories",
        entityId: collection?.id,
    });

    const handleUpdate = (selectedCollection) => {
        categoryActionsNew.update({
            data: { ...selectedCollection, id: collection?.id },
            options: {
                onSuccess: () => {
                    sendNotification({
                        message: `Promjene su uspješno spremljene!`,
                        type: "success",
                    });
                },
                onError: () =>
                    sendNotification({
                        message: `Nešto je pošlo po zlu!`,
                        type: "error",
                    }),
            },
        });
    };
    const handleDelete = () => {
        categoryActionsNew.delete({
            data: { id: collection?.id },
        });
        sendNotification({
            message: `Kolekcija je uspješno obrisana!`,
            type: "success",
        });

        if (id === collection?.id) {
            if (categories.length > 1) {
                const currentIndex = categories.findIndex((item) => item.id === collection?.id);
                if (currentIndex === categories.length - 1) {
                    push(`/moj-profil/spremljeno/${categories[currentIndex - 1].id}`);
                } else {
                    push(`/moj-profil/spremljeno/${categories[currentIndex + 1].id}`);
                }
            } else {
                push("/inspiracija");
            }
        }
        dispatch({ type: DRAWER_ACTIONS.POP_CONTENT, payload: { drawerType: "collections-edit" } });
    };

    return (
        <>
            <Editor
                isLoading={isLoading}
                collection={collection}
                onUpdate={handleUpdate}
                onDelete={handleDelete}
            />
            <Notification uid={NOTIFICATION_ID} />
        </>
    );
};

export default withErrorBoundary(CollectionsEdit);
